import React from 'react';

export const renderReportSelectionCriteria = (headers, data) => {
    return (
        <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
            <thead className="table-header">
                <tr key="headers"> {headers.map(header => <td>{header.title}</td>)} </tr>
            </thead>
            <tbody>
                {data.map((document, index) =>
                    <tr key={index}>
                        {headers.map(header => <td>{header.format ? header.format(document[header.field]) : document[header.field]}</td>)}
                    </tr>
                )}
            </tbody>
        </table>
    );
}